var _StorageRepository_name, _StorageRepository_storage;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { empty } from '../Strings';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
import createStorageKey from './utilities/createStorageKey';
import read from './utilities/read';
import write from './utilities/write';
export default class StorageRepository {
    constructor(storage, name = empty) {
        _StorageRepository_name.set(this, void 0);
        _StorageRepository_storage.set(this, void 0);
        __classPrivateFieldSet(this, _StorageRepository_name, name, "f");
        __classPrivateFieldSet(this, _StorageRepository_storage, storage, "f");
    }
    deleteAsync(key) {
        const _key = createStorageKey(__classPrivateFieldGet(this, _StorageRepository_name, "f"), key);
        const value = read(__classPrivateFieldGet(this, _StorageRepository_storage, "f"), _key);
        if (!isUndefinedOrNull(value)) {
            write(__classPrivateFieldGet(this, _StorageRepository_storage, "f"), _key, undefined);
        }
        return Promise.resolve();
    }
    getAsync(key) {
        return Promise.resolve(read(__classPrivateFieldGet(this, _StorageRepository_storage, "f"), createStorageKey(__classPrivateFieldGet(this, _StorageRepository_name, "f"), key)));
    }
    setAsync(key, entity) {
        const _key = createStorageKey(__classPrivateFieldGet(this, _StorageRepository_name, "f"), key);
        const value = read(__classPrivateFieldGet(this, _StorageRepository_storage, "f"), _key);
        if (!isUndefinedOrNull(value)) {
            write(__classPrivateFieldGet(this, _StorageRepository_storage, "f"), _key, entity);
        }
        return Promise.resolve();
    }
}
_StorageRepository_name = new WeakMap(), _StorageRepository_storage = new WeakMap();
